/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import req_res_cycleImg from 'assets/images/req-res-cycle.jpeg'
import sslImg from 'assets/images/ssl.jpeg'
import http_httpsImg from 'assets/images/http-https.png'
import http_versionsImg from 'assets/images/http-versions.png'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Протоколы передачи данных</h2>
    <p className={styles.description}>
      <b>Протокол</b> — набор правил и соглашений, используемых при передаче данных в сети.
    </p>
    <p className={styles.description}>
      Перед тем как пользователь увидит содержимое сайта на экране, браузер делает запрос на сервер, чтобы получить это
      самое содержимое. HTML-файл, изображения, стили, скрипты - каждый элемент приходит с сервера.
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.1 - TCP/IP</h3>
      <p className={styles.description}>
        Основополагающий протокол сети <b>Internet</b>. Это - два протокола тесно связанных между собой.
      </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <b>TCP (Transmission Control Protocol)</b> — протокол управления передачей. Определяет, каким образом
          информация должна быть разбита на пакеты и отправлена по каналам связи. TCP располагает пакеты в нужном
          порядке, а также проверяет каждый пакет на наличие ошибок при передаче.
        </li>
        <li className={styles.list__item}>
          <b>IP (Internet Protocol)</b> — каждый информационный пакет содержит IP-адреса компьютера-отправителя и
          компьютера-получателя. Специальные компьютеры, называемые маршрутизаторами, используя IP-адреса, направляют
          информационные пакеты в нужную сторону, то есть к указанному в них получателю.
        </li>
      </ul>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.2 - HyperText Transfer Protocol (HTTP)</h3>
      <p className={styles.description}>
        Браузер запрашивает и получает данные через HTTP-протокол, поэтому браузер еще называют HTTP-клиентом.
      </p>
      <p className={styles.description}>
        <b>Протокол передачи гипертекста (HTTP)</b> — специально разработанный протокол как основа World Wide Web,
        используется для передачи всех необходимых типов данных: html, изображений, аудио и видео, css, javascript и т.
        д. Дефолтный TCP-порт — <code className={styles.code}>80</code>.
      </p>
      <p className={styles.description}>
        HTTP основан на модели <b>клиент-сервер</b> и протоколе <b>запрос-ответ</b>, который работает путем обмена
        сообщениями через надежное TCP/IP соединение.{' '}
      </p>
      <img className={styles.img} src={req_res_cycleImg} alt="req-res-cycle" />
      <p className={styles.description}>
        Есть клиент, который инициирует соединение и посылает запрос и сервер, который ожидает соединения для получения
        запроса, производит необходимые действия и возвращает обратно сообщение с результатом. Связь между ними
        осуществляется посредством череды перемежающихся HTTP-запросов и HTTP-ответов.{' '}
      </p>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>1.2.1 - HyperText Transfer Protocol Secure (HTTPS)</h4>
        <p className={styles.description}>
          <b>HTTPS</b> — это надстойка над HTTP-протоколом, в которой все сообщения между клиентом и сервером шифруются
          в целях повышения безопасности. Обеспечивает защиту от атак, основанных на прослушивании соединения. Данные
          передаются поверх криптографических протоколов SSL или TLS. Дефолтный TCP-порт —{' '}
          <code className={styles.code}>443</code>.{' '}
        </p>
        <img className={styles.img} src={sslImg} alt="ssl" />
        <p className={styles.description}>
          При общении через обычное HTTP-соединение все данные передаются в виде текста и могут быть прочитаны всеми,
          кто получил доступ к соединению между клиентом и сервером. Если пользователь делает покупки онлайн и заполняет
          форму заказа, содержащую информацию о кредитной карте, их финансовые данные гораздо легче украсть, если они
          передаются в виде текста. С HTTPS данные будут зашифрованы и хакер не сможет их расшифровать, потому что для
          расшифровки необходим доступ к закрытому ключу, который хранится на сервере.{' '}
        </p>
        <img className={styles.img} src={http_httpsImg} alt="http-https" />
        <ul className={styles.list}>
          <li className={styles.list__item}>
            Информация о клиенте, например номера кредитных карт, зашифрована и не может быть перехвачена в
            расшифрованном виде.
          </li>
          <li className={styles.list__item}>
            Посетители могут подтвердить, что сайт безопасен, посмотрев на иконку слева от адресной строки, защищенные
            соединения помечаются иконкой замка.
          </li>
          <li className={styles.list__item}>
            Клиенты с большей вероятностью будут доверять и совершать покупки с сайтов, использующих HTTPS.
          </li>
        </ul>
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>1.2.2 - На что тратит время HTTP-запрос</h4>
        <p className={styles.description}>Запрос происходит в несколько этапов: </p>
        <ul className={styles.list}>
          <li className={styles.list__item}>
            <a
              className={styles.link}
              href="https://www.youtube.com/watch?v=72snZctFFtA&feature=youtu.be"
              target="_blank"
              rel="noopener noreferrer"
            >
              DNS-запрос{' '}
            </a>
            — поиск ближайшего DNS-сервера, чтобы преобразовать адрес (например google.com ) в его числовое
            представление, IP-адрес (74.125.87.99).
          </li>
          <li className={styles.list__item}>
            <b>Соединение</b> — установка соединения с сервером по полученному IP-адресу.
          </li>
          <li className={styles.list__item}>
            <b>Отправка данных</b> — пересылка пакетов с клиента на сервер.
          </li>
          <li className={styles.list__item}>
            <b>Ожидание ответа</b> — ждем, пока пакеты данных дойдут до сервера, он их обработает и ответ вернется
            назад.
          </li>
          <li className={styles.list__item}>
            <b>Получение данных</b> — пакеты пришли, можно получать из них данные.
          </li>
        </ul>
      </section>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.3 - HTTP/1.1 и HTTP/2</h3>
      <img className={styles.img} src={http_versionsImg} alt="http-versions" />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.4 - Дополнительные материалы</h3>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://www.youtube.com/playlist?list=PLzdnOPI1iJNfMRZm5DDxco3UdsFegvuB7"
            target="_blank"
            rel="noopener noreferrer"
          >
            Плейлист - How The Internet Works
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://youtu.be/AEaKrq3SpW8?list=PL8dPuuaLjXtNlUrzyH5r6jN9ulIgZBpdo"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Internet: Crash Course Computer Science #29
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://youtu.be/guvsH5OFizE?list=PL8dPuuaLjXtNlUrzyH5r6jN9ulIgZBpdo"
            target="_blank"
            rel="noopener noreferrer"
          >
            The World Wide Web: Crash Course Computer Science #30
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="http://infocisco.ru/network_model_osi.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Сетевая модель
          </a>
        </li>
      </ul>
    </section>
  </section>
))
